import { createFileRoute } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { ShearingCsvImportContainer } from '@/components/screens/shearing/shearing-csv-import-container'

export const Route = createFileRoute('/t/$tenant_id/shearing_certificates/csv_import')({
  component: ShearingCsvImportPage,
})

function ShearingCsvImportPage() {
  const { tenant_id: tenantId } = Route.useParams()
  return (
    <div className="flex min-h-screen">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1">
        <ShearingCsvImportContainer key={tenantId} tenantId={tenantId} />
      </main>
    </div>
  )
}
